define('sentient/aba/main',[
    'require',
    'modernizr',
    'jquery',
    'underscore',
    'loglevel',
    'domReady',
    'purl',
    './app',
    './models/SessionModel',
    './models/SessionScriptModel',
    './models/SessionResultModel',
    './models/SetupModel',
    './models/WindowModel',
    './views/SessionView',
    './views/WindowView',
    './views/WindowCanvasView',
    './collections/ProjectsCollectionProxy',
    './collections/PrimesCollection',
    './views/PrimeView',
    './Sounds',
    './router'
], function(require, modernizr, $, _, log, domReady, purl, app, SessionModel, SessionScriptModel, SessionResultModel, SetupModel, WindowModel, SessionView, WindowView, WindowCanvasView, ProjectsCollectionProxy, PrimesCollection, PrimeView, Sounds, Router) {

    if (!_.isEmpty($.url().param('loglevel'))) {
        //Move setLevel into a try/catch to prevent it stoping in old IE
        try {
            log.setLevel($.url().param('loglevel'));
        } catch (err) {}
    } else {
        try {
            log.setLevel('silent');
        } catch (err) {}
    }

    log.trace('main.js');
    $('.waiting-to-run-main').removeClass('waiting-to-run-main');

    var urlParams = $.url().param();

    //This lets up override bits of the script.
    var overrides = _.reduce(urlParams, function(memo, value, key, list) {
        if (key.match(/override-/)) {
            key = key.replace(/^override-/, '');
            if (key.match(/sessionScript-/)) {
                key = key.replace(/^sessionScript-/, '');
                if (!memo['sessionScript']) {
                    memo['sessionScript'] = {
                        'all': {}
                    };
                }
                if (key.match(/^exercise-\d*/)) {
                    var Ex = key.replace(/^exercise-(\d*)-.*/, '$1');
                    key = key.replace(/^exercise-\d*-(.*)/, '$1');
                    if (!memo['sessionScript'][Ex]) {
                        memo['sessionScript'][parseInt(Ex, 10)] = {};
                    }
                    memo['sessionScript'][parseInt(Ex, 10)][key] = value;
                } else {
                    memo['sessionScript']['all'][key] = value;
                }
            }
        }
        return memo;
    }, {
        'sessionScript': null
    });
    //log.debug('overrides',overrides);

    var RespId = $.url().param('RespId');
    var ProjectId = $.url().param('ProjectId');
    var Ex = $.url().param('Ex').split(',');

    if ($.url().param('sampleData') === '') {
        app.sampleData = true;
    }
    if ($.url().param('randomPlay') === '') {
        app.randomPlay = true;
    }
    var skipIntro = false;
    if ($.url().param('skipIntro') === '' || app.randomPlay || app.sampleData) {
        skipIntro = true;
    }
    var skipExIntro = false;
    if ($.url().param('skipExIntro') === '' || app.randomPlay || app.sampleData) {
        skipExIntro = true;
    }
    var skipCountdown = false;
    if ($.url().param('skipCountdown') === '' || app.randomPlay || app.sampleData) {
        skipCountdown = true;
    }




    //Display end icons? (yes/no).
    var endicons = true;
    if ($.url().param('endicons') === '') {
        endicons = false;
    }

    app.subconsciousAssociations = false;
    if ($.url().param('subconscious-associations') === '') {
        app.subconsciousAssociations = true;
    }

    //app.endCallback = $.url().param('endCallback');
    //app.endCallbackScriptUrl = $.url().param('endCallbackScriptUrl');
       //Special case for &caller=ssiweb in URL.
    //See ticket: https://sentientdecisionscience.atlassian.net/browse/PRIME-229
    if ($.url().param('caller') === "ssiweb") {
        app.endCTA = "Close Window";
    app.caller = "ssiweb";
} else {
    app.endCTA = $.url().param('endCTA');

        app.endRedir = $.url().param('endRedir');

}


    //log.debug('Session parameter:', RespId, ProjectId, Ex);

    domReady(function(document) {
        $(document).on(
            'show-console', //Event name
            '.sentient-aba', //Selector
            {
                'this': this
            }, //Data
            function($event) {
                $(document).find('.sentient-aba').addClass('console');

                //Load up our console code if we need to
                if (!(app.console)) {
                    //log.debug('$event.data.this', $event.data['this']);
                    require(['require', './Console'], function(require, console) {
                        app.console = new console();
                    });
                }
            });

        $(document).on('hide-console', '.sentient-aba', null, function($event) {
            $('.sentient-aba').removeClass('console');
        });
    });

    //Default Error handler for jQuery ajax.
    $(this.document).ajaxError(function(e, xhr, options, message) {
        log.error('Ajax error: ' + options.type + ' ' + options.url + ' ( ' + message + ' )');
    });

    var appRootUrl = '/api';

    //Create a model that will track changes to the window width, height or both.
    app.windowModel = new WindowModel();
    $(window).on('resize', $.proxy(function() {
        this.model.updateValuesFromEnv(this.$sessionView, this.$window);
    }, {
        'model': app.windowModel,
        '$sessionView': $('.sentient-aba-session'),
        '$window': $(window)
    }));
    app.windowModel.updateValuesFromEnv($('.sentient-aba-session'), $(window));
    app.windowView = new WindowView({
        model: app.windowModel
    });
    domReady(function() {
        app.windowModel.updateValuesFromEnv($('.sentient-aba-session'), $(window));
    });

    //app.windowView.trigger('resize-check');


    //Create a session model
    app.sessionModel = new SessionModel({
        'RespId': RespId,
        'ProjectId': ProjectId,
        'Ex': Ex,
        'overrides': overrides
    });
    app.sessionModel.serviceHost = appRootUrl;

    //Get the sample data if reqested in the URL parameters.
    if (app.sampleData) {
        $.getJSON(appRootUrl + '/projects/sampleData/' + ProjectId + '/' + Ex, function(data) {
            if (data && data.exercises) {
                app.sessionResultModel.set('exercises', data.exercises);

                var jumpToEnd = function(sessionScriptModel) {
                    var script = sessionScriptModel.get('sessionScript');
                    if (script && script.length !== null) {
                        sessionScriptModel.set('stepCount', script.length - 2);
                    }
                };

                var script = app.sessionScriptModel.get('sessionScript');
                //if the script has not been loaded, wait for the sync event from the model
                if (script.length == 1 && script[0] && script[0].type == 'noop') {
                    app.sessionScriptModel.once('sync', function(sessionScriptModel) {
                        jumpToEnd(sessionScriptModel);
                    });
                } else {
                    jumpToEnd(app.sessionScriptModel);
                }

            }
        });
    }


    //Create a Session View and populate it with the model
    app.sessionView = new SessionView({
        'model': app.sessionModel
    });
    app.sessionView.listenTo(app.windowModel, 'change:windowWidth', function(model) {
        if (app.sessionView.model.get('pausable')) {
            app.sessionView.model.set({
                paused: true
            });
        }
        app.sessionView.model.set('width', this.$el.width());
        app.sessionView.model.set('height', this.$el.height());
    });
    //app.sessionView.resize();
    //app.sessionModel.set('speed', 0.5);
    //app.sessionModel.set('accuracy', 0.5);
    app.sessionModel.set('taskCount', 0);
    app.sessionModel.set('bucket-top', ' ');
    app.sessionModel.set('bucket-bottom', ' ');
    app.sessionScriptModel = new SessionScriptModel({
        'RespId': RespId,
        'ProjectId': ProjectId,
        'Ex': Ex
    });
    app.sessionScriptModel.serviceHost = appRootUrl;
    //
    app.sessionScriptModel.on('progress', function(progress) {
        //log.debug('progress',progress);
        $('#loading-text').each(function(index, el) {
            var event = document.createEvent('Event');
            event.initEvent('Stop', true, true);
            event.target = el;
            el.dispatchEvent(event);
        });
        $('.sentient-aba-session-frame.loading .bottom-text')
            .text('Loading Session: ' + Math.round(Math.min(progress.total / progress.loaded, 1) * 100).toString() + '%');
    })
        .on('error', function(error) {
            $('#loading-text').each(function(index, el) {
                var event = document.createEvent('Event');
                event.initEvent('Stop', true, true);
                event.target = el;
                el.dispatchEvent(event);
            });
            $('.sentient-aba-session-frame.loading .bottom-text')
                .text('Error: ' + error.message);
        });

    //Define a ImageResource Model
    var ImageResource = Backbone.Model.extend({
        'defaults': {
            'loaded': false
        },
        'initialize': function(initVal) {
            var image = initVal.image || new Image();
            if (!image.getAttribute('src')) {
                image.setAttribute('src', initVal.url || initVal.id);
                this.set('image', image);
            }
            this.listenTo(this, 'change:loaded', function() {
                if (this.collection) {
                    this.collection.trigger('ImageResourceLoaded', this);
                }
            });
            this.listenTo(this, 'change:error', function() {
                if (this.collection) {
                    this.collection.trigger('ImageResourceError', this);
                }
            });
            image.addEventListener('load', $.proxy(function(event) {
                this.set('loaded', true);
            }, this));
            image.addEventListener('error', $.proxy(function(event) {
                this.set('error', true);
            }, this));
            if (typeof image.naturalWidth != 'undefined' && image.naturalWidth > 0) {
                this.set('loaded', true);
            }
        }
    });

    //Create a model that will hold the urls to all the media used in this session.
    var SessionMedia = Backbone.Collection.extend({
        'model': ImageResource,
        'initialize': function() {
            this.on('ImageResourceLoaded CheckImageResourceLoaded', function(imageModel, $event) {
                //log.debug("SessionMedia got event: ", imageModel);
                var loadedCount = this.where({
                    'loaded': true
                }).length;
                var totalCount = this.length;
                this.trigger('progress', {
                    'total': totalCount,
                    'loaded': loadedCount
                });
                if (loadedCount == totalCount) {
                    //log.debug("SessionMedia indicates that all media has loaded.");
                    this.trigger('load');
                }
                /*
                log.debug({
                    "loadedCount": loadedCount,
                    "totalCount": totalCount
                });*/

            });
            this.on('ImageResourceError', function(error) {
                log.error('ImageResourceError', arguments);
                $('.sentient-aba-session-frame.loading .bottom-text')
                    .text('Error: ' + error.message);
            });
        }
    });
    app.sessionMedia = new SessionMedia();

    //Track the load progress of any images found in the dom.
    domReady(function() {

        _(document.images).each(function(image, index, list) {
            var url = image.getAttribute('src');

            if (!_.isEmpty(url) && url.indexOf("http") === 0) { // <-- yes, sometimes img dont have any value in thier src...
                app.sessionMedia.add({
                    'id': image.getAttribute('src'),
                    'url': url,
                    'image': image
                });
            }
        });
    });
    //Track any images that have been spesified in the session script.
    app.sessionMedia.listenTo(app.sessionScriptModel, 'change:sessionMedia', function(model, value, options) {
        if (value && value.images) {
            _(value.images).each(function(url, index, list) {
                app.sessionMedia.add({
                    'id': url,
                    'url': url
                });
            });
        }
    });
    app.sessionMedia.on('progress', function(progress) {
        $('.sentient-aba-session-frame.loading .bottom-text')
            .text('Loaded Media: ' + progress.loaded + ' of ' + progress.total + '.');
    });

    app.sounds = new Sounds(app.sessionView.el);

    //Create a library of exercises for this session
    app.exercises = new ProjectsCollectionProxy();
    app.exercises.listenTo(app.sessionScriptModel, 'change:sessionExercises', function(model, value, options) {
        app.exercises.reset();
        _.each(value, function(exercise, index, list) {
            exercise['exerciseId'] = index;
            app.exercises.add(exercise);
        });
    });

    app.sessionResultModel = new SessionResultModel({
        'RespId': RespId,
        'ProjectId': ProjectId,
        'AppId': 'aba'
    });
    app.sessionResultModel.serviceHost = appRootUrl;

    //get the setupModel for each Ex

    app.setupModel = [];
    _.each(Ex, function(ExNum, index, list) {

        app.setupModel[ExNum] = new SetupModel({
            'RespId': RespId,
            'ProjectId': ProjectId,
            'Ex': [ExNum]
        });
    });

    var onSessionScript = function(values, status, jqXHR) {
        //log.debug("app.sessionScriptModel.fetch().done",arguments,this);
        if (app.sessionModel.get('overrides')) {
            var overrides = app.sessionModel.get('overrides');
            if (overrides['sessionScript']) {
                app.sessionScriptModel.applyOverrides(overrides['sessionScript']);
            }
        }

        //If endicons has been set to false, modify the session script to had the icons at the end.
        if (!endicons) {
            var sessionScript = app.sessionScriptModel.get('sessionScript');
            _.chain(sessionScript)
                .where({
                    type: 'sessionEnd'
                })
                .each(function(sessionEnd) {
                    _.extend(sessionEnd.options, {
                        iconsVisible: false
                    });
                });
        }

        app.sessionResultModel.set('SessionId', app.sessionScriptModel.get('SessionId'));

        //Create all the task and prime elements (including pre-loading any images).
        var taskResources = app.sessionScriptModel.getAllTaskResources();
        //log.debug('All Task Resources:', taskResources);
        _(taskResources).each(function(value) {
            //log.debug("Task:", value);
            if (value && value.name && value.source && value.type && value.type == 'image') {
                app.sessionView.addImageTask(
                    value.name,
                    value.source,
                    value.correctBucket || "none",
                    value.timeout,
                    value.exerciseId,
                    value.targetType,
                    value.topBucket,
                    value.bottomBucket
                );
            }
            if (value && value.name && value.source && value.type && value.type == 'text') {
                app.sessionView.addTextTask(
                    value.name,
                    value.source,
                    value.correctBucket || "none",
                    value.timeout,
                    value.exerciseId,
                    value.targetType,
                    value.topBucket,
                    value.bottomBucket
                );
            }
        });
        var primeResources = app.sessionScriptModel.getAllPrimeResources();
        //log.debug("All Prime Resources:",primeResources);
        app.primes = new PrimesCollection();

        app.primeView = new PrimeView({
            'collection': app.primes
        });

        //We listen to window resizing
        app.primeView.listenTo(app.windowModel, 'change:size', function(model, value, options) {
            var newSize = {
                'width': value.width,
                'height': value.height
            };
            this.setSize(newSize);
        });
        app.primes.listenTo(app.windowModel, 'change:size', function(model, value, options) {
            this.each(function(prime, primeName, list) {
                prime.calculateDimensions(value.width, value.height);
            });
        });
        app.primeView.render();

        _(primeResources).each(function(value, key, list) {
            //log.debug('Prime:', value);
            if (value && value.name && value.source && value.type && value.type == 'image') {
                app.primes.add({
                    'id': 'prime-' + value.name,
                    'name': value.name,
                    'source': value.source,
                    'time': value.primingTime,
                    'preliminarytime': value.preliminarytime,
                    'type': 'image'
                });
                app.sessionView.addImagePrime(value.name, value.source, value.preliminaryTime, value.primingTime);
            }
            if (value && value.name && value.source && value.type && value.type == 'text') {
                app.primes.add({
                    'id': 'prime-' + value.name,
                    'name': value.name,
                    'source': value.source,
                    'time': value.primingTime,
                    'preliminarytime': value.preliminarytime,
                    'type': 'text'
                });
                app.sessionView.addTextPrime(value.name, value.source, value.preliminaryTime, value.primingTime);
            }
        });

        app.windowModel.trigger('change:size', app.windowModel, app.windowModel.get('size'));
        //log.debug('app.primes:', app.primes);

        /* I decided that the stepForward code does not belong inside of
      Session Script Model or Session Model because it connects the two together.
      I did not want to have one depend on the other. So the funtion lives out here in main.js */

        app.on('stepForward', function() {
            domReady($.proxy(function(document) {
                //log.debug('event:',this);
                if (!app.sessionModel.get('paused')) {
                    var step;
                    if (app.sessionModel.get('practice')) {
                        step = app.practiceScript.shift();
                        //log.debug("in practice step",step);
                        if (step['type'] == 'returnToScript') {

                            app.sessionModel.unset('practice');
                            var currentStep = app.sessionScriptModel.currentStep();
                            var peekback = app.sessionScriptModel.peekBack();
                            //log.debug("currentStep",currentStep);
                            //log.debug("peekback",peekback);
                            if (currentStep.type == 'exerciseCountDown') {
                                app.trigger('stepForward');
                            } else if (currentStep.type == 'task' && peekback.type == 'prime') {
                                app.sessionScriptModel.stepBack();
                                app.sessionScriptModel.stepBack();
                                app.trigger('stepForward');
                            } else if (currentStep.type == 'task' || currentStep.type == 'prime') {
                                app.sessionScriptModel.stepBack();
                                app.trigger('stepForward');
                            }
                        }
                    } else {
                        step = app.sessionScriptModel.stepForward();
                    }


                    if (_.isObject(step)) {
                        app.sessionModel.trigger(step['type'], step['options']);


                        if (skipExIntro && step['type'] == 'exerciseChange') {
                            setTimeout(function() {
                                app.trigger('stepForward');
                            }, 1000);

                        }
                        if (skipCountdown && step['type'] == 'exerciseCountDown') {
                            setTimeout(function() {
                                app.trigger('stepForward');
                            }, 1000);
                        }
                    }

                    //log.debug('app.sessionModel.trigger(', step['type'], ',', step['options'], ')');

                }
            }), this);
        }); //End on('stepForward'
        app.on('pause', function() {
            app.sessionModel.trigger('pause', {});
        });
        app.on('unpause', function() {
            var exerciseId = app.sessionModel.get('exerciseId');
            //log.debug('unpause currentStep', );
            //log.debug('unpause', app.exercises);
            var currentStep = app.sessionScriptModel.currentStep();
            var exercise = app.exercises.findWhere({
                'exerciseId': exerciseId.toString()
            });
            app.sessionModel.set('practice', true);
            app.practiceScript = exercise.createPracticeScript(3, currentStep['options']['stepUID']);
            app.trigger('stepForward');
        });

        app.on('restart', function() {
            //log.debug('App got restart request!', app);
            app.sessionResultModel.clear();
            app.sessionResultModel.set({
                'RespId': RespId,
                'ProjectId': ProjectId,
                'AppId': 'aba'
            });
            app.sessionScriptModel.restart();
            app.trigger('stepForward');
        });

        //As soon as the sessionMedia collection says that all the images are loaded, start the session
        app.sessionMedia.once('load', function() {
            $('.sentient-aba-session-frame').removeClass('loading');
            if (skipIntro) {
                app.trigger('start');
            }
            $('.aba-instructions .dialog-confirm-btn')
                .empty()
                .removeClass('wait-for-load')
                .text('Continue')
                .one('click', function() {
                    app.sounds.playSilence();
                    app.trigger('start');
                });
            app.trigger('stepForward');
        });
        app.on('start', function() {
            $('.sentient-aba-session-loader').remove();
            $('.hide-until-instructions-are-removed').removeClass('hide-until-instructions-are-removed');
            app.windowView.trigger('resize-check');
            $('body').scrollTop(0);
        });
        app.sessionMedia.trigger('CheckImageResourceLoaded', {});
        //app.windowView.trigger('resize-check');
        $(window).trigger('resize');
    };
    //log.debug(app.sessionScriptModel);
    //log.debug(JSON.stringify(window.screen));
    app.sessionScriptModel.fetch().done(onSessionScript);

    app.router = new Router();
    Backbone.history.start();
});
